import type { PropertyTrackingStatus } from '~/api/gen'
import { propertyTrackingStatusEnum } from '~/api/gen'

/**
 * Statut de suivi des biens mockés, un par phase (Règles métiers « Cycle de vie & statut de suivi »).
 * Phases, libellés et transitions se déduisent de `form-rules/property-lifecycle.json` : ils ne sont pas mockés.
 */

/** Brouillon — mandat en attente de signature (location). */
export const trackingBrouillon: PropertyTrackingStatus = propertyTrackingStatusEnum.MANDATE_PENDING_SIGNATURE

/** Actif — offre déposée (vente). */
export const trackingActif: PropertyTrackingStatus = propertyTrackingStatusEnum.OFFER_SUBMITTED

/** Finalisation — compromis en cours (vente). */
export const trackingFinalisation: PropertyTrackingStatus = propertyTrackingStatusEnum.AGREEMENT_IN_PROGRESS

/** Archivé — vendu : statut terminal, aucune transition. */
export const trackingArchive: PropertyTrackingStatus = propertyTrackingStatusEnum.SOLD
